// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__22CM0","actions":"GroupTable_actions__3Ph6m","deleteModalFooter":"GroupTable_deleteModalFooter__3yge_"};